import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext, useDictionary } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";

import { dictionaryService } from "../../../dataFlow";
import { getCalendarParameterSelection } from "../utils/getCalendarParameterSelection";
import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [commodities, setCommodities] = useParameter<number[]>("@commodities");
  const [displayCommodities, setDisplayCommodities] = useParameter<number[]>("@commodities_display");
  const [units, setUnits] = useParameter<number[]>("@units");

  const [selectedCommodityId] = useParameter<number>("@selected_commodity_id");
  const [selectedUnitId] = useParameter<number>("@selected_unit_id");
  const [calendar] = useParameter<number[]>("@calendar");

  const [dictItems] = useDictionary(dictionaryService, "calendar-origin");

  useEffect(() => {
    if (calendar != null && dictItems) {
      const calendarParameterSelection = getCalendarParameterSelection(calendar, dictItems);

      setTitle(title);
      setSubtitle(subtitle);
      setParameters({
        "@selected_commodity_id": selectedCommodityId,
        "@selected_unit_id": selectedUnitId,
        "@calendar": calendarParameterSelection,
        "@commodities": commodities,
        "@units": units,
      });
    }
  }, [title, subtitle, calendar, commodities, units, selectedCommodityId, selectedUnitId, dictItems, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      setCommodities((parameters["@commodities"].value as string[]).map(Number));
      setUnits((parameters["@units"].value as string[]).map(Number));
      // setDisplayCommodities((parameters["@commodities_display"].value as string[]).map(Number));
    },
    [setCommodities, setUnits, setDisplayCommodities]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
